import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoginService } from '@services/login.service';
import { Config } from '@config/config.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private loginService: LoginService,
    private router: Router,
    private config: Config
  ) {}

  canActivate(
    router: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const queryParams = router.queryParams;
    const params: any = {queryParams};
    const routeParams = router.params;

    return this.checkLogin(state.url, params, routeParams);
  }

  checkLogin(url: any, params: any, routeParams: any): boolean {
    const isLoggedIn: boolean = this.loginService.isLoggedIn;
    const urlToSend = url.indexOf('?') > -1 ? url.substring(0, url.indexOf('?')) : url;

    if (!isLoggedIn) {
      this.loginService.redirectUrl = urlToSend;
      this.loginService.redirectParams = params;
      this.router.navigate([
        `${this.config.pages.login}`
      ]);
    }

    return isLoggedIn;
  }
}
